import { Route, Routes } from "react-router";
import loadable from "@loadable/component";
// import HomePage from "@/page/HomePage";
import ConnectionPage from "@/page/ConnectionPage";
import ThankYouPage from "@/components/common/ThankYouPage";
// import FeedBackFormPage from "@/components/form/feedBackForm";
import ConnectFormCanera from "@/components/form/ConnectFormCanera";
import FeedBackFormCanera from "@/components/form/feedBackFormCanera";

const App = loadable(() => import("../container/App"));
// const ConnectPage = loadable(() => import("../page/ConnectPage"));
// const UserLobby = loadable(() => import("../page/UserLobbyPage"));
// const VideoCallScreen = loadable(() => import("../page/VideoCallScreen"));

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<App />}>
        <Route path="/" element={<ConnectFormCanera />} />
        {/* <Route path="/connect" element={<ConnectPage />} /> */}
        <Route path="/videoCall" element={<ConnectionPage />} />
        {/* <Route path="/UserFeedback" element={<FeedBackFormPage />} /> */}
        <Route path="/ThankYou" element={<ThankYouPage />} />
        {/* <Route path="/connected-VC" element={<ConnectFormCanera />} /> */}
        <Route path="/UserFeedback" element={<FeedBackFormCanera />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
